import React from 'react';
import moment from 'moment';
import isEqual from 'lodash.isequal';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { teacherHighlight } from '../Login/AmiraTheme';

const DATE_RANGE_KEY = "theOnlyDateRange";

class DateRangePicker extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { dateRange } = this.props;
    this.state = {
      dateRange: {
        ...props.dateRange,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        key: DATE_RANGE_KEY,
      },
    };

    this.minDate = new Date();//prevent setting a start date in the past
    this.onDateRangeChange = this.onDateRangeChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { dateRange } = this.props;
    if(!isEqual(dateRange, prevProps.dateRange)) {
      this.setState({
        ...this.state,
        dateRange: {
          ...dateRange,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          key: DATE_RANGE_KEY,
        },
      });
    }
  }

  onDateRangeChange(item) {
    if(this.props.onDateRangeChange && item[DATE_RANGE_KEY].startDate && item[DATE_RANGE_KEY].endDate){
      const endDate = moment(item[DATE_RANGE_KEY].endDate).endOf("day").toDate();
      item[DATE_RANGE_KEY].endDate = endDate;
      this.props.onDateRangeChange(item[DATE_RANGE_KEY]);
    }
  }

  render() {
    return (
      <div className="dateRangePickerContainer">
        <DateRange
          direction="horizontal"
          showDateDisplay={true}
          months={2}
          minDate={this.minDate}
          onChange={this.onDateRangeChange}
          moveRangeOnFirstSelection={false}
          ranges={[this.state.dateRange]}
          rangeColors={[teacherHighlight]}
        />
      </div>
    );
  }
}

export default DateRangePicker;
